import * as React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAppSelector } from "../store/hooks";

interface Props {
    children: React.ReactNode;
}

const RestrictedRoute = ({ children }: Props) => {
    const location = useLocation();
    const { pathname } = location;

    // Extract last path segment, e.g. '/recommended-doctors' → 'recommended-doctors'
    const pathKey = pathname.split("/").filter(Boolean).pop() || "";

    const { restrictions = [], userType } = useAppSelector((s) => s.auth);
    const isManagement = userType?.toLowerCase().includes("management");
    const isAdmin = userType?.toLowerCase().includes("admin");

    if (pathKey === "upload" && !isManagement) {
        return <Navigate to="/dashboard" replace />;
    }

    if (pathKey === "admin-dashboard" && !isAdmin) {
        return <Navigate to="/dashboard" replace />;
    }

    if (isManagement && restrictions.includes(pathKey) && pathKey !== "management-dashboard") {
        return <Navigate to="/management-dashboard" replace />;
    }

    if (restrictions.includes(pathKey)) {
        return <Navigate to="/dashboard" replace />;
    }

    return <>{children}</>;
};

export default RestrictedRoute;
